export default __webpack_public_path__ + "static/media/our-process-02.4b4b65d6.jpg";